if (!customElements.get("pulsing-dot")) {
	const constants = {
		FACTOR: 0.2,
		FINAL_OPACITY: 0.01,
		SCALE_FACTOR: 4,
		DEFAULT_ANIMATION: "pulse",
		DEFAULT_ANIMATION_DURATION: 1000,
		DEFAULT_ANIMATION_TIMING: "ease-in-out",
		DEFAULT_ANIMATION_ITERATION_COUNT: Infinity,
	}

	class PulsingDot extends HTMLElement {
		constructor() {
			super();
		}

		get dot() {
			return this.querySelector("[data-pulsing-dot]");
		}

		get animationTiming() {
			return this.getAttribute("animation-timing") || constants.DEFAULT_ANIMATION_TIMING;
		}

		get animationDuration() {
			return Number(this.getAttribute("animation-speed")) * 1000 || constants.DEFAULT_ANIMATION_DURATION;
		}

		get animationScaleFactor() {
			return Number(this.getAttribute("animation-scale-factor")) || constants.SCALE_FACTOR;
		}

		get defaultAnimation() {
			return this.getAttribute("default-animation") || constants.DEFAULT_ANIMATION;
		}

		get shouldAutoAnimate() {
			return this.getAttribute("auto-animate") === "true";
		}

		get keyframes() {
			const animationScaleFactor = Number((this.animationScaleFactor / (this.animationScaleFactor + constants.FACTOR)).toFixed(2));
			const steps = [];
			const opacity = 1 / (this.animationScaleFactor * 2);

			for (let i = 0; i < this.animationScaleFactor; i++) {
				steps.push(`scale(${animationScaleFactor + i})`);
			}

			return steps.map((step, index) => ({ transform: step, opacity: index === steps.length - 1 ? constants.FINAL_OPACITY : opacity * (index + 1) }));
		}

		get reverseKeyframes() {
			return this.keyframes.reverse();
		}

		get animationIterationCount() {
			const animationIteration = this.getAttribute("animation-iterations");
			if (!animationIteration || animationIteration === "infinite") {
				return Infinity;
			}

			return animationIteration;
		}

		_pulse() {
			this.dot.animate(this.keyframes, {
				duration: this.animationDuration,
				easing: this.animationTiming,
				iterations: this.animationIterationCount
			});
		}

		_reversePulse() {
			this.dot.animate(this.reverseKeyframes, {
				duration: this.animationDuration,
				easing: this.animationTiming,
				iterations: this.animationIterationCount
			});
		}

		pulse({ animationDuration = this.animationDuration, animationTiming = this.animationTiming, animationIterationCount = this.animationIterationCount } = {}) {
			this.dot.animate(this.keyframes, {
				duration: animationDuration,
				easing: animationTiming,
				iterations: animationIterationCount
			});
		}

		reversePulse({ animationDuration = this.animationDuration, animationTiming = this.animationTiming, animationIterationCount = this.animationIterationCount } = {}) {
			this.dot.animate(this.reverseKeyframes, {
				duration: animationDuration,
				easing: animationTiming,
				iterations: animationIterationCount
			});
		}

		startDefaultAnimation() {
			if (this.defaultAnimation === "pulse") {
				this._pulse();
			} else {
				this._reversePulse();
			}
		}

		connectedCallback() {
			if (this.shouldAutoAnimate) {
				this.startDefaultAnimation();
			};
		}
	}

	customElements.define("pulsing-dot", PulsingDot);
}